import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserFacePaintingGame from 'src/games/FacePainting/Main';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(XraySliderGame)'
interface FacePaintingGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface FacePaintingGameState {
}

class FacePaintingGame extends React.Component<FacePaintingGameProps, FacePaintingGameState> {
    constructor(props: FacePaintingGameProps) {
        super(props);
        bindAllOfThis(this, FacePaintingGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserFacePaintingGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default FacePaintingGame;



// WEBPACK FOOTER //
// ./src/pages/game/FacePaintingGame.tsx